// extracted by mini-css-extract-plugin
var _1 = "ReturnButton-moduleReturnButton__X0MKq";
export { _1 as "ReturnButton" }
